import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { TransactionsService } from 'src/app/services/transactions.service';

@Component({
  selector: 'app-list-transactions',
  templateUrl: './list-transactions.component.html',
  styleUrls: ['./list-transactions.component.css']
})
export class ListTransactionsComponent implements OnInit {
 eventsSubject: Subject<any> = new Subject<any>();


  displayedColumns: string[] = ['name', 'store', 'status', 'description',  'actions'];
  columnsToDisplay = [{field: 'name', header: 'Nome', type: 'text'}, {field: 'description', header: 'Descrição', type: 'text'}];
  columnsObject = [{field: 'store', object:'store', subObject:'name', header: 'Loja', type: 'select', selectFieldsDados: []},];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados:  [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: false, view: true, delete: false, statusUpdate: false};
  title = 'Transações';
  page: any = {base: null, name: null};
  service;
  buttons = [];

  constructor(private storeService: StoreService,
    private route: ActivatedRoute,
    private transactionsService: TransactionsService,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.transactionsService.getAll;
this.storeService.getAll(null).pipe(first())
      .subscribe(
          data => {
            console.log('lojas', data);
            this.columnsObject[0].selectFieldsDados = data['content'];
          },
          error => {
            console.log('error', error);
        });
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  this.buttons.push({title:'Redimir Pontos', fn: this.redimir, icon:'filter_list'});
  }

  redimir = (args, selected): void => {
    console.log(args, selected);
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.id } });
    }
    view = (args: any): void => {
      console.log(args);
      //this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.id } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.transactionsService.inactive(args.id);
      textConfirm = 'Pretende Desactivar a Transação ' + args.name + '? Ao desactivar a Transação o estado da Transação será alterado para INATIVO.';
      status = 'INACTIVE';
      textShow = 'TRANSAÇÃO DESATIVADO COM SUCESSO';
    }
    else{
      service = this.transactionsService.active(args.id);
      textConfirm = 'Pretende Activar a Transação ' + args.name + '? Ao activar a Transação o estado da Transação será alterado para ATIVO';
      status = 'ACTIVE';
      textShow = 'TRANSAÇÃO ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar esta Transação ' + args.name + '? Ao eliminar os dados da Transação serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.transactionsService.delete(args.id).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }

